import { Group, Mesh, MeshLambertMaterial, CubeTextureLoader, CubeTexture, CubeReflectionMapping, Color, MeshStandardMaterial } from "three";
const cubeDoorUrl = `${process.env.PUBLIC_URL}/assets/textures/cube_sky/`;

const loadCubeTexture = () =>
    new Promise<CubeTexture>((res) => {
        const cubeTextureLoader = new CubeTextureLoader();

        const format = ".jpg";
        const urls = [
            cubeDoorUrl + "px" + format,
            cubeDoorUrl + "nx" + format,
            cubeDoorUrl + "py" + format,
            cubeDoorUrl + "ny" + format,
            cubeDoorUrl + "pz" + format,
            cubeDoorUrl + "nz" + format,
        ];

        cubeTextureLoader.load(urls, (refractionCube) => {
            refractionCube.mapping = CubeReflectionMapping;

            res(refractionCube);
        });
    });

export const updateWindowMaterials = async (object: Group) => {
    const envMap = await loadCubeTexture();
    const glassMaterial = getGlassMaterial(envMap);

    object.traverse((elem) => {
        if ((elem as Mesh).isMesh) {
            const mesh = elem as Mesh;
            if (Array.isArray(mesh.material)) {
                for (let i = 0; i < mesh.material.length; i++) {
                    const mat = mesh.material[i];

                    if (mat.type === "MeshPhongMaterial") {
                        if (mat.name === "glass") {
                            mesh.material[i] = glassMaterial;
                            mesh.material[i].needsUpdate = true;
                        }
                    }
                }
            } else {
                if (mesh.material.type === "MeshStandardMaterial") {
                    if (mesh.material.name === "glass") {
                        mesh.material = glassMaterial;
                        mesh.material.needsUpdate = true;
                    } else {
                        const material = mesh.material as MeshStandardMaterial;

                        material.color = new Color(0xffffff);
                        material.metalness = 0.5;
                        material.roughness = 0.8;
                        material.flatShading = true;
                        material.needsUpdate = true;
                    }
                }
            }
        }
    });

    object.userData.isMapLoaded = true;
};

export const getGlassMaterial = (envMap: CubeTexture) => {
    return new MeshLambertMaterial({
        envMap,
        reflectivity: 1.6,
    });
};
